/**
 * Module « campagne » — la séquence la plus importante de l’année
 * (CAM-01 à CAM-06, SPEC-FONCTIONNELLE §6).
 *
 * Cinq écrans, montés sous `/admin/campagne` (rôles admin et guichet) :
 *
 *   `/admin/campagne`                 tableau de bord — où en est la campagne
 *   `/admin/campagne/correspondances` étape 1 — quelle formule remplace quelle formule
 *   `/admin/campagne/generation`      étape 2 — générer les propositions
 *   `/admin/campagne/bulletins`       étape 3 — traiter les réponses reçues
 *   `/admin/campagne/phases`          étape 4 — ouvrir la phase interne, puis externe
 *
 * Le layout résout la saison de travail (paramètre d’URL `?saison=`) et la
 * publie à tous les écrans ; le routeur, lui, n’importe que `routesCampagne`
 * (ARCHITECTURE §11).
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

import { LayoutCampagne } from './LayoutCampagne'

// Feature lourde (SPEC §6, cinq écrans du fil rouge de la campagne) : chaque
// étape n’est chargée que lorsqu’on y navigue (ARCHITECTURE §9.4, découpage
// par feature). Le `<Suspense>` qui affiche le repli est posé dans `LayoutAdmin`.
const TableauDeBord = lazy(() => import('./pages/TableauDeBord').then((m) => ({ default: m.TableauDeBord })))
const Correspondances = lazy(() =>
  import('./pages/Correspondances').then((m) => ({ default: m.Correspondances })),
)
const Generation = lazy(() => import('./pages/Generation').then((m) => ({ default: m.Generation })))
const Bulletins = lazy(() => import('./pages/Bulletins').then((m) => ({ default: m.Bulletins })))
const Phases = lazy(() => import('./pages/Phases').then((m) => ({ default: m.Phases })))

export const routesCampagne: RouteObject[] = [
  {
    element: <LayoutCampagne />,
    children: [
      { index: true, element: <TableauDeBord /> },
      { path: 'correspondances', element: <Correspondances /> },
      { path: 'generation', element: <Generation /> },
      { path: 'bulletins', element: <Bulletins /> },
      { path: 'phases', element: <Phases /> },
    ],
  },
]
